/* eslint-disable */
// Make sure webpack knows where to lazy-load chunks.
// This needs to loaded as the FIRST import.
__webpack_public_path__ = window.resourceBasePath || '/';
/* eslint-enable */
